import PageHandler from "./PageHandler";
import Pages from "Pages";

class LicensesInUseListPageHandler extends PageHandler {
  constructor() {
    super("licenses-in-use-list", Pages.LicensesInUseListPage);
  }

  async fetch(parameters) {
    await this.rootStore.data.LicensesInUseStore.fetchByLicenseId(parameters.licenseId);
    // Load License
    await this.rootStore.data.LicensesStore.fetchId(parameters.licenseId);
    // Load users
    const license = this.rootStore.data.LicensesStore.findById(parameters.licenseId);
    this.rootStore.data.UsersStore.fetchByCustomerId(license.CustomerId);

    this.rootStore.data.ApplicationsStore.fetch();
  }
}

export default LicensesInUseListPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/LicensesInUseListPageHandler.js